export function LoadingState(loading = 0, message = '') {
	return { loading: Integer(loading), message };
}

function Integer(x: unknown): number {
	return Number.isInteger(x) ? (x as number) : 0;
}
